import React from 'react';

import BackgroundImage from '../../BackgroundImage';
import styles from './playerInviteCard.scss';
import { sportTypeIds } from '../../../utils/eventConstants';
import { getPickleBallRating, setRatingChoice, getRatingDetails } from '../../../utils';
import PbrRating from '../../text/PbrRating';

const PlayerInviteCard = ({
    player,
    isOrganizer = false,
    onRemovePlayer,
    onPlayerSelected,
    showRemoveButton,
    isSelectable = false,
    sportTypeId = sportTypeIds.TENNIS,
    'data-testid': dataTestId,
}) => {
    const { id, displayName, location, playerProfileImages } = player.source;

    const singlesRating = getRatingDetails(setRatingChoice({ player: player.source, ratingType: 'singles' }), false, false, false, false);
    const doublesRating = getRatingDetails(setRatingChoice({ player: player.source, ratingType: 'doubles' }), false, false, false, false);
    const pkbRating = getPickleBallRating(player.source, null);

    const handleOnRemovePlayer = () => {
        onRemovePlayer(id);
    };

    const handleOnPlayerSelected = () => {
        if (isSelectable) {
            onPlayerSelected(id);
        }
    };
    const displayRating = singlesRating.value === 'UR' && doublesRating.value === 'UR' && !singlesRating.showPBRRating && !doublesRating.showPBRRating ? 'Unrated' : null;
    const locationDisplay = location?.display ? `${location.display} \u2022` : '';

    return (
        <div onClick={handleOnPlayerSelected} className={`${isSelectable ? styles.selectableContainer : styles.container}`}>
            <div className={`${styles.imageContainer} avatar-wrapper`}>
                <BackgroundImage
                    baseUrl={'/v1/player/'}
                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                    images={playerProfileImages}
                    imageType={'profile'}
                    extraCls={'playerThumbnailImage'}
                />
            </div>
            <div>
                <div className={styles.infoContainer}>
                    <div className={styles.name} data-testid={dataTestId && `${dataTestId}.name`}>{displayName}</div>
                    <div data-testid={dataTestId && `${dataTestId}.organizer-label`}>{`${isOrganizer ? ' (organizer)' : ''}`}</div>
                </div>
                {parseInt(sportTypeId) === sportTypeIds.PICKLEBALL
                    ? <div className={styles.rating} data-testid={dataTestId && `${dataTestId}.pickleball-rating`}>{`${locationDisplay} ${pkbRating.value || 'UR'}`}</div>
                    : (
                        <div className={styles.infoContainer}>
                            <div className={styles.rating} data-testid={dataTestId && `${dataTestId}.location`}>{locationDisplay}</div>
                            &nbsp;
                            {!displayRating && (
                                <div className={styles.infoContainer}>
                                    <span className={styles.rating} data-testid={dataTestId && `${dataTestId}.singles-rating`}> {singlesRating.showPBRRating ? <PbrRating pbrRating={singlesRating.pbrRating} /> : singlesRating.value}</span>
                                    &nbsp;
                                    <span className={styles.rating} data-testid={dataTestId && `${dataTestId}.singles-label`}>{'(s)'}</span>
                                    &nbsp;
                                    <span className={styles.rating} data-testid={dataTestId && `${dataTestId}.doubles-rating`}> {doublesRating.showPBRRating ? <PbrRating pbrRating={doublesRating.pbrRating} /> : doublesRating.value} </span>
                                    &nbsp;
                                    <span className={styles.rating} data-testid={dataTestId && `${dataTestId}.doubles-label`}>{'(d)'}</span>
                                </div>
                            )}
                            {displayRating && (
                                <div className={styles.rating} data-testid={dataTestId && `${dataTestId}.unrated-label`}> {displayRating} </div>
                            )}
                        </div>
                    )}
            </div>
            {showRemoveButton && (
                <div className={styles.buttonContainer}>
                    <div className="close-icon" onClick={handleOnRemovePlayer} data-testid={dataTestId && `${dataTestId}.remove-btn`}><i className="utr utr-close" /></div>
                </div>
            )}

        </div>
    );
};

PlayerInviteCard.defaultProps = {
    'data-testid': null,
};

export default PlayerInviteCard;
